import { autoinject } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { EventLogsClientService } from "../../../../../services/event-log/event-log-client.service";

@autoinject()
export class ChangeLogsStatusDialog { 
    public nextStatusReasonId: number;
    public eventLogType: EntityTypes = EntityTypes.EventLog;
    public ids: number[];
    public reload: () => void;

    public statusId: number;
    public statusReasonId: number;
    public nextStatusReasonLogNotes: string;

    constructor(private logsService: EventLogsClientService,
        private dialogClientService: DialogClientService,
        private notificationService: NotificationClientService) { }

    activate(model: { ids: number[], reload: () => void, statusId: number, statusReasonId: number }) {
        this.ids = model.ids;
        this.reload = model.reload;
        this.statusId = model.statusId;
        this.statusReasonId = model.statusReasonId;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    changeStatus() {
        this.logsService.changeStatus(this.ids, this.nextStatusReasonId, this.nextStatusReasonLogNotes).then(() => {
            this.notificationService.show("Success", "Status changed successfully", NotificationType.Success);
            this.dialogClientService.hide();
            if (this.reload) {
                this.reload();
            }
        }).catch(() => {
            this.notificationService.show("Error", "Failed to change Status", NotificationType.Error);
        })
    }
}